import React, { Component } from "react";
import { Grid, Row, Col, Table } from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import { thArray, tdArray } from "variables/Variables.jsx";

import logintoaccount from "assets/img/log-in-to-account.png";
import logoutoftrial from "assets/img/log-out-of-trial.png";

class LicenseKeyActivation extends Component {
  constructor(props) {
      super(props);
  }

  render() {
    return (
      <div className="content">

      {this.props.authDetail.detail.haszine || this.props.authDetail.detail.hascreative?

        <div className="card">
            <div className="header">
                <h3 className="title">License Activation Using Desktop Publisher</h3>
            </div>
            <div className="content">
              <p>To use FlowPaper using our desktop publisher, simply log in using your email and access code. You will be able to fill in the domain name where you would like to publish your documents inside the desktop publisher. </p>

              <img src={logintoaccount} style={{width:'100%'}} />

              <br/><br/><br/>

              <h4 className="title">Already logged in?</h4>
              <p>Already logged in using the trial account? Log out using the top left button and log in with your account.</p>

              <img src={logoutoftrial} style={{width:'50%'}} />
            </div>
        </div>

      :''}

        <div className="card">
          <div className="header">
              <h3 className="title">Manual License Key Activation</h3>
          </div>
          <div className="content">
            <p>You can activate your license by editing the html page which includes the viewer. Install your license by adding your key to the javascript parameters that are passed to the viewer:</p>

            <pre className="prettyprint">
            {`
            $('#documentViewer').FlowPaperViewer(
              { config : {
                PDFFile : "Paper.pdf",
                Scale : 0.6,
                key : "$1234567890ABC",
            ..
            `}
            </pre>
          </div>
        </div>
    
      </div>
    );
  }
}

export default LicenseKeyActivation;
